
import { CompanySettingsModel }         from '../companies/models/company.settings';
import { MobileService }                from './mobile.service';
import { MobileVideoSettingsComponent } from './mobile.video-settings.component';
import { SessionService }               from '../sessions/session.service';

export const MobileStates : Array<any> = [
  {
    component: MobileVideoSettingsComponent,
    name     : 'app.video-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : ng.IPromise<any> => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ MobileService ],
        resolveFn: ( mobileService : MobileService ) : ng.IPromise<CompanySettingsModel> => mobileService.getSettings(),
        token    : 'settings'
      },
      {
        deps     : [ MobileService ],
        resolveFn: ( mobileService : MobileService ) : ng.IPromise<string> => mobileService.getVideoStorageMinutes(),
        token    : 'videoStorageMinutes'
      }
    ],
    url: '/video-settings'
  }
];
